<template>
  <div class="wrap">
    <div class="main">
      <div class="login">
        <i class="iconfont icon-back-left" @click="goBack"></i>
        <!-- <img src="@img/logo_white.png"> -->
        <div class="logo">
          <img src="@img/bitfinex-logo.png" alt="">
          <span>BITFINEX</span>
        </div>
      </div>
      <div class="login-info">
        <label>
          <i class="iconfont icon-zhanghao"></i>
          <input type="text" v-model="uname" :placeholder="lang.enaccount">
        </label>
        <label>
          <i class="iconfont icon-mima"></i>
          <input type="password" v-model="pwd" :placeholder="lang.password">
        </label>
      </div>
      <div class="login-footer">
        <p class="login-btn" @click="doLogin">{{lang.login}}</p>
        <!-- <p class="langue">
          <span @click="setLan(1)" v-if="langArr.indexOf('en')>-1">ENGLISH</span>
          <span @click="setLan(0)" v-if="langArr.indexOf('cn')>-1">中文</span>
        </p> -->
        <p class="bottom">
          <router-link to="/Reg">{{lang.reg}}</router-link>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState} from 'vuex';
  import { CONF,API_SERVER } from '@/assets/js/config'
  import {xhrGet} from "../api/api";
  export default {
    data() {
      return {
        uname: '',
        pwd: '',
        langType:'',
        langArr:'',
      }
    },
    mounted() {
      this.getSysConf()
    },
    computed: {
      ...mapState(['lang','ulang'])
    },
    methods: {
      goBack() {
        this.$router.push('/');
      },
      // doLogin() {
      //   this.$router.push('Index')
      // },
      getSysConf(){
        this.$indicator.open(this.lang.loading);
        this.$xhrGet( '/system/config')
          .then(res => {
            this.$indicator.close();
            if (res.err == 0) {
              this.langArr = res.lang;
              this.cs_url = res.cs_url;
              this.appDownload = res.android;
              this.$store.dispatch('set_langTypes',this.langArr);
              this.$store.dispatch('set_siteName',res.siteName);
              this.$store.dispatch('set_appDownLoad',this.appDownload);
              document.title = res.siteName || this.logoName;
            }else if (res.err == 200||res.err == 201){
              this.$router.push({
                name:'Maintenance',
                query:{
                  num:res.err
                }
              })
            }else{
              this.$messagebox({
                title: this.lang.tip,
                message: res.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      },
      setLan(lan){
        this.$indicator.open(this.lang.loading);
        let choselang = lan?'en':'cn';
        this.$doRequest('post', '/index/setLang',{lang:choselang})
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              let lang = {};
              for(let i in language){
                lang[i] = language[i][lan]
              }
              this.$store.dispatch('set_ulang',choselang);
            }else{
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      },
      doLogin() {
        if (!this.uname) {
          this.$messagebox({
            title: this.lang.tip,
            message: this.lang.enaccount,
            confirmButtonText: this.lang.confirm
          });
          return false;
        }
        if (!this.pwd) {
          this.$messagebox({
            title: this.lang.tip,
            message: this.lang.enpassword,
            confirmButtonText: this.lang.confirm
          });
          return false;
        }
        this.logining = true;
        this.$indicator.open(this.lang.loading);
        this.$xhrPost('/member/login', {
            uname: this.uname,
            pwd: this.pwd,
            lang:this.ulang || CONF.LANG
          })
          .then(res => {
            this.$indicator.close();
            this.logining = false
            if (res.err == 0) {
              this.$toast({
                message: this.lang.logsucc,
                iconClass: 'iconfont icon-chenggong',
                duration: 2000
              })
              if(res.tk) sessionStorage.setItem('tk', res.tk);
              this.$store.dispatch('set_userInfo',{uname: this.uname,blc:res.blc,vip:res.vip})
              setTimeout(()=>{
                this.$router.push('/')
              },2000)
            }else if (res.err == 102) {
              sessionStorage.setItem('tk', res.tk);
              this.doLogin();
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.logining = false
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      },
    }
  }
</script>
<style scoped >
  .logo img{
    width: 36px;
  }
  .logo span{
    font-size: 36px;
    color: #dbf1ff;
  }
  .login {
    width: 100%;
    height: 200px;
    background: url(../assets/images/logo-bg.png) no-repeat center center;
    background-size: cover;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .login  .iconfont {
    position: absolute;
    width: 40px;
    height: 40px;
    line-height: 40px;
    top: 0;
    left: 12px;
    color: #fff;
  }

  .login-info  label {
    position: relative;
    display: block;
    width: 80%;
    height: 40px;
    line-height: 40px;
    margin: 20px auto;
    display: flex;
    font-size: 16px;
    align-items: center;
    border: 1px solid #aaa;
    border-radius: 5px;
  }
  .login-info  label i {
    display: inline-block;
    width: 40px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-right: 1px solid #aaa;
    color: #999;
  }

  .login-info  label input {
    flex: 1;
    height: 40px;
    background: none;
    padding-left: 5px;
  }

  .login-info  label img {
    position: absolute;
    top: 1px;
    right: 1px;
    height: 36px;
  }
  .login-footer {
    width: 80%;
    margin: 10px auto;
    color: #999;
  }
  .login-footer p {
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    margin: 12px auto;
    font-size: 16px;
    text-align: center;
  }
  .login-footer p  a {
    color: #999;
  }

  .login-footer .login-btn {
    background: #0183FF;
    margin-top: 20px;
    color: #fff;
  }
  .langue {
    display: flex;
    justify-content: space-around;
    color: #333;

  }
  .langue  span {
    flex: 1;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    border: 1px solid #0183FF;
  }
  .bottom{
    color: #999;
    position: relative;
  }
  .bottom::before{
    position: absolute;
    content: '';
    top:50%;
    left:0;
    right:0;
    height: 1px;
    background: #ddd;
  }
  .bottom a{
    padding:0 10px;
    position: relative;
    background: #fff;
    z-index: 1;
  }
</style>